import { useShallow } from 'zustand/shallow';

import { getPresetChord } from 'app/modules/wallforming/components/input-binding/utils/inputBindingUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { selectActiveInputProfile } from 'app/modules/wallforming/components/state-management/placement/slices/inputBindingSlice';

import type { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';

/** Props of every binding editor strategy. */
export interface BindingEditorProps {
    actionId: InputActionId;
    slot: number;
}

/** Primitive-only selection so slot rows re-render only when their own slot changes. */
export const useGetInputBindingSlot = (actionId: InputActionId, slot: number) =>
    usePlacementStore(
        useShallow((state) => {
            const chord = state.inputBindings.slots[actionId][slot];
            const captureTarget = state.inputCaptureTarget;
            return {
                chord,
                isModified: chord !== getPresetChord(selectActiveInputProfile(state), actionId, slot),
                isReadOnly: Boolean(selectActiveInputProfile(state).readOnly),
                isCapturing: captureTarget?.actionId === actionId && captureTarget?.slot === slot
            };
        })
    );
